import type React from "react";
import { useTranslation } from "react-i18next";

import config from "@/constants/config";

type CartItemModifierBlockProps = {
  name: string;
  description?: string;
  amount: number;
  grossSum: number;
};

export const CartItemModifierBlock: React.FC<CartItemModifierBlockProps> = ({
  name,
  description = "",
  amount,
  grossSum,
}) => {
  const { t } = useTranslation("cartPage");

  return (
    <li>
      {grossSum > 0
        ? t("CartItemBlock.modifierLine.withPrice", {
            name: name,
            description: description,
            singlePrice: grossSum,
            count: amount,
            totalPrice: grossSum * amount,
            formatParams: {
              totalPrice: {
                currency: config.appConfig.currency.currencyCode,
                locale: config.appConfig.currency.formatLocale,
              },
              singlePrice: {
                currency: config.appConfig.currency.currencyCode,
                locale: config.appConfig.currency.formatLocale,
              },
            },
          })
        : t("CartItemBlock.modifierLine.withoutPrice", {
            name: name,
            description: description,
            count: amount,
          })}
    </li>
  );
};
